import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import React from "react";
import { Permission, PutUserRequest } from "../../../models/auth";
import PermissionSelector from "./PermissionSelector";

interface EditUserFormProps {
  readonly form: PutUserRequest;
  readonly setForm: (form: PutUserRequest) => void;
  readonly handleEditSubmit: () => void;
}

export default function EditUserForm({ form, setForm, handleEditSubmit }: EditUserFormProps) {
  const isCloudAuth = window.CONFIG?.auth?.kind !== "SIMPLE";

  const handlePermissionChange = (permissions: Permission[]) => {
    setForm({
      ...form,
      attributes: {
        ...form.attributes,
        permissions: permissions,
      },
    });
  };
  return (
    <form
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        handleEditSubmit();
      }}
    >
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between">
          <FormControl>
            <FormLabel>Given name</FormLabel>
            <Input
              required
              value={form.attributes.given_name}
              onChange={(e) => {
                setForm({
                  ...form,
                  attributes: {
                    ...form.attributes,
                    given_name: e.target.value,
                  },
                });
              }}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Last name</FormLabel>
            <Input
              required
              value={form.attributes.name}
              onChange={(e) => {
                setForm({
                  ...form,
                  attributes: {
                    ...form.attributes,
                    name: e.target.value,
                  },
                });
              }}
            />
          </FormControl>
        </Stack>

        <PermissionSelector
          selectedPermissions={form.attributes.permissions || []}
          onChange={handlePermissionChange}
          isCloudAuth={isCloudAuth}
        />
        <FormControl>
          <FormLabel>Organization</FormLabel>
          <Input
            value={form.attributes.organization ?? ""}
            onChange={(e) => {
              setForm({
                ...form,
                attributes: {
                  ...form.attributes,
                  organization: e.target.value,
                },
              });
            }}
          />
        </FormControl>
        <Button type="submit">Submit</Button>
      </Stack>
    </form>
  );
}
